import PropTypes from 'prop-types';
import BasePaymentModal from '../shared/modals/payment';

function PaymentModal(props) {
  const content = (
    <div>
      <p className='text-medium'>
        <span>موجودی کیف پول شما برای خرید بسته مشاوره </span>
        <span>'{props.packageName}'</span>
        <span> کافی نمی‌باشد.</span>
      </p>
      <p>
        <span className='text-medium'>هزینه پکیج: </span>
        <span>{props.order.price.toLocaleString()}</span>
        <span> ریال</span>
      </p>
      {props.order.code && (
        <>
          <p>
            <span className='text-medium'>مقدار تخفیف: </span>
            <span>{props.order.code.amount}</span>
            <span> درصد</span>
          </p>
          <p>
            <span className='text-medium'>هزینه نهایی: </span>
            <span>{props.order.paymentPrice.toLocaleString()}</span>
            <span> ریال</span>
          </p>
        </>
      )}
    </div>
  );

  return (
    <BasePaymentModal
      open={props.open}
      content={content}
      onClose={props.onClose}
      orderId={props.order.id}
      amount={props.order.paymentPrice}
      createPayment={pay}
    />
  );
}

async function pay(createPayment, orderId) {
  const {payload: {url}} = await createPayment(orderId);
  window.location.replace(url);
}

PaymentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  packageName: PropTypes.string.isRequired,
  order: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

export default PaymentModal;
